import React from 'react';
import styleError from './ErrorPage.module.css';
import { FormTitle } from '../../TemporaryConmonents/Authorization/Register/FormTitle/FormTitle';

const errorData = {
    404: {
        title: i18next.t('ErrorContent.return.errorData.error404.title'),
        subTitle: () => <span>{i18next.t('ErrorContent.return.errorData.error404.subTitle')}</span>,
    },
    403: {
        title: i18next.t('ErrorContent.return.errorData.error403.title'),
        subTitle: () => (
            <span>
                {i18next.t('ErrorContent.return.errorData.error403.subTitle.part1')}
                <a href="mailto:support@smetter.ru">
                    {i18next.t('ErrorContent.return.errorData.error403.subTitle.part2')}
                </a>
            </span>
        ),
    },
    500: {
        title: i18next.t('ErrorContent.return.errorData.error500.title'),
        subTitle: () => <span>{i18next.t('ErrorContent.return.errorData.error500.subTitle')}</span>,
    },
};

export function ErrorContent({ errorCode }) {
    return (
        <div>
            <div className={styleError.errorCode}>{errorCode}</div>
            <FormTitle
                title={errorData[errorCode].title}
                subtitle={errorData[errorCode].subTitle()}
            />
        </div>
    );
}
